"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// HINT: cruiseapi converts PREMIUM to IND
exports.PriceModelPremium = 'PREMIUM';
exports.PriceModelVario = 'VARIO';
exports.PriceModelUrlaubskasse = 'UK';
exports.PriceModelMitarbeiter = 'MIT';
exports.PriceModelAngehoerige = 'ANG';
exports.PriceModelProductExperienceProgram = 'PEP';
exports.PriceModelProductExperienceProgramExpedient = 'PEPEX';
exports.PriceModelFamilyAndPartners = 'FUP';
exports.PriceModelJust = 'JUST';
exports.PriceModelSeetours = 'SEETOURS';
exports.PriceModelPauschal = 'PAUSCHAL';
//# sourceMappingURL=price_model.js.map